//REACT AND REACT BASED LIBRARIES
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useSWRMutation from "swr/mutation";
//COMPONENTS
import { Box, Container } from "@mui/material";
import AddEditFormCst from "@components/AddEditFormCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
//CUSTOM HOOKS AND UTILS
import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { MethodType } from "src/services/type";
import { PagesID } from "@utils/utilsConfigurations";
import { fetcher } from "src/services/config";

const AddProject: React.FC = () => {
  const { t } = useTranslation(["manage-projects-page"]);
  const { id, IdPlan } = useParams();
  const navigate = useNavigate();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const { columns, dataDetail, mutate } = useFetchDetail(
    undefined,
    undefined,
    PagesID["corporate.foundedTraining.managePlan.project.add"],
  );

  const { trigger } = useSWRMutation(
    `${ServicesURL.addProject
      .replace(":corporateId", id || "")
      .replace(":planId", IdPlan || "")}`,
    (url: string, arg: { arg: any }) => {
      return fetcher<any>(`${url}`, MethodType.POST, { ...arg.arg });
    },
  );

  const inputsException = (col: any, inputForm: any) => {
    if (col.accessorKey === "id_ol") {
      col.required = false;
      return {};
    }
    if (col.accessorKey === "id") {
      col.required = false;
      return {};
    }
    return col;
  };

  const onSubmit = async (inputForm: any) => {
    const objToSend = {
      project_code: inputForm.project_code,
      project_title: inputForm.project_title,
      note: inputForm.note,
    };

    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
    try {
      await trigger(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
    }
    mutate && mutate(objToSend);
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-skills-capabilities.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("add.hero-title")} description={""} />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              row={dataDetail || []}
              columns={columns}
              onSubmit={onSubmit}
              actionsForForms={[]}
              backButton={() => {
                navigate(-1);
              }}
              inputsException={inputsException}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={""}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default AddProject;
